import { EditOutlined, FieldTimeOutlined } from '@ant-design/icons';
import { Button, Card, Col, Row } from 'antd';
import AddCheckTime from 'components/Modals/attendanceLog/AddCheckTime';
import dayjs from 'dayjs';
import useGetAttendanceLog from 'hooks/query/workSchedule/useGetAttendanceLog';
import i18next, { t } from 'i18next';
import { UserModel } from 'models/users';
import { CheckTimeModel } from 'models/workSchedule';
import React, { useEffect, useState } from 'react'
import { isTechnical } from 'utils/helpers/check-roles';
import { UserData } from 'utils/helpers/encrypt-decrypt-user';

const AttendanceLog = () => {
  const [User, setUser] = useState<UserModel | null>(null);
  const [openAddCheckTime, setOpenAddCheckTime] = useState<{open: boolean, type: string}>({
    open: false,
    type: "",
  })
  const [selectedAttendance, setSelectedAttendance] = useState<CheckTimeModel | null>(null);
  const { data: attendanceLog, isLoading, refetch } = useGetAttendanceLog(
    {
      user_id: isTechnical(User?.role_id!) ? User?.id : undefined,
      search: "",
    },
    {
      enabled: !!User
    }
);

  useEffect(() => {
    setUser(UserData.Decrypt());
  }, []);


  return (
    <div>
      <div style={{display: "flex", gap: "5px", flexWrap: "wrap"}}>
        <Button
          onClick={() => setOpenAddCheckTime({open: true, type: "check_in"})}
          type="primary"
          icon={<FieldTimeOutlined />}
          style={{ display: isTechnical(User?.role_id!) && !User?.checked_in ? "flex" : "none"}}
        >
          {t("add_check_in")}
        </Button>
        <Button
          onClick={() => setOpenAddCheckTime({open: true, type: "check_out"})}
          type="primary"
          icon={<FieldTimeOutlined />}
          style={{ display: isTechnical(User?.role_id!) && !User?.checked_out ? "flex" : "none"}}
        >
          {t("add_check_out")}
        </Button>
      </div>
        <Row gutter={[16,16]} style={{textAlign: i18next.language === "en" ? "left" : "right", marginTop: "10px"}}>
          {attendanceLog?.data.map((element: any, index: any) => (
              <Col key={index} md={8} sm={12} xs={24}>
                <Card style={{height: "100%"}} title={
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <p style={{margin: "0px"}}>{element?.technical_name}</p>
                    {isTechnical(User?.role_id!)
                      ? <></>
                      :
                    <div 
                    onClick={()=>{setOpenAddCheckTime({open: true, type: "edit"}); setSelectedAttendance(element)}}
                    style={{
                      backgroundColor: "#28befa", 
                      width: "fit-content", 
                      padding: "3px 5px", 
                      borderRadius: "5px", color: "white",
                      cursor: "pointer"
                      }}>
                      <EditOutlined />
                    </div>
                    }
                  </div>
                } variant="borderless">
                  <div>
                    <p>{t("checkin_time")} : {element?.checkin_time 
                    ? i18next.language === "en" 
                      ? dayjs(element.checkin_time).format("YYYY-MM-DD HH:mm:ss")
                      : dayjs(element.checkin_time).format("DD-MM-YYYY HH:mm:ss")
                    : "-"}</p>
                    <p>{t("checkout_time")} : {element?.checkout_time 
                    ? i18next.language === "en" 
                      ? dayjs(element.checkout_time).format("YYYY-MM-DD HH:mm:ss")
                      : dayjs(element.checkout_time).format("DD-MM-YYYY HH:mm:ss") 
                    : "-"}</p>
                    <p>{t("over_time")} : {element?.over_time}</p>
                    <p>{t("total_time")} : {element?.total_time}</p>
                  </div>
                </Card>
              </Col>
          ))}
        </Row>


      <AddCheckTime
          openAddCheckTime={openAddCheckTime}
          setOpenAddCheckTime={setOpenAddCheckTime}
          selectedAttendance={selectedAttendance}
          setSelectedAttendance={setSelectedAttendance}
          setUser={setUser}
        />
    </div>
  )
}

export default AttendanceLog